import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

async function trigger(axios: AxiosInstance, verificationId: number | undefined) {
  await axios.get(`${config.apiBaseUrl}/op/v2/workshop-verification-request/${verificationId}/send-poa-email`);
}

export default function useSendPowerOfAttorneyEmailMutation(verificationId: number | undefined) {
  const axios = useAxios();
  const toast = useToast();

  return useMutation({
    mutationFn: () => trigger(axios, verificationId),
    onSuccess: () =>
      toast({
        title: 'Power of Attorney Email Sent',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top',
      }),
  });
}
